import { CSS_CLASSES, MESSAGES } from "../constants/app";
import { InlineLoading } from "./loading/LoadingIndicators";
import PatientDetailModal from "./PatientDetailModal";

export interface ReportComparisonModalProps {
  isOpen: boolean;
  onClose: () => void;
  subtitle?: string;
  html: string;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
}

function stripHtmlFences(raw: string): string {
  if (raw.includes("```html")) {
    const htmlMatch = raw.match(/```html\s*([\s\S]*?)\s*```/);
    if (htmlMatch) {
      return htmlMatch[1].trim();
    }
  }
  if (raw.includes("```")) {
    const codeMatch = raw.match(/```\s*([\s\S]*?)\s*```/);
    if (codeMatch) {
      return codeMatch[1].trim();
    }
  }
  return raw.trim();
}

export default function ReportComparisonModal({
  isOpen,
  onClose,
  subtitle,
  html,
  loading,
  error,
  onRetry,
}: ReportComparisonModalProps) {
  const comparisonHtml = stripHtmlFences(html);

  return (
    <PatientDetailModal
      isOpen={isOpen}
      onClose={onClose}
      title={MESSAGES.COMPARE.TITLE}
      subtitle={subtitle}
      size="xl"
      closeDisabled={loading}
      bodyClassName="px-4 py-5 sm:px-8 sm:py-6"
      footer={
        error ? (
          <>
            <button
              type="button"
              className={CSS_CLASSES.BUTTONS.CANCEL_MODAL}
              onClick={onClose}
            >
              Close
            </button>
            <button
              type="button"
              className={CSS_CLASSES.BUTTONS.PRIMARY_MODAL}
              onClick={onRetry}
            >
              Try again
            </button>
          </>
        ) : (
          <button
            type="button"
            className={CSS_CLASSES.BUTTONS.CANCEL_MODAL}
            disabled={loading}
            onClick={onClose}
          >
            Close
          </button>
        )
      }
    >
      {loading ? (
        <InlineLoading message={MESSAGES.LOADING.COMPARISON} />
      ) : error ? (
        <p className="text-sm text-rag-red" role="alert">
          {error}
        </p>
      ) : comparisonHtml ? (
        <div
          className="text-sm leading-5 text-guardian-header [&_table]:my-2 [&_table]:w-full"
          dangerouslySetInnerHTML={{ __html: comparisonHtml }}
        />
      ) : (
        <p className="text-sm text-guardian-header">No comparison available.</p>
      )}
    </PatientDetailModal>
  );
}
